module.exports = __webpack_public_path__ + "components/weather-icon/static/daythunderstorm@2-c658db738dff6c98bcd47187577cd6a7.png";